import React from "react";
import { Link } from "react-router-dom";

const SinglePost = ({ post }) => {
  const { title, body, id } = post;
  return (
    <div>
      <h1>this is single post</h1>
      <h4>{title}</h4>
      <p>{body}</p>

      <Link to={`/post/${id}`}>visit {id}</Link>
    </div>
  );
};

export default SinglePost;
